import { LEADS_DELETE_CURRENT_LEADS_DATA, LEADS_SAVE_CURRENT_LEADS_DATA } from '../constants'

export function reducer(state, action) {
  switch (action.type) {
    case LEADS_SAVE_CURRENT_LEADS_DATA:
      return{
        ...state,
        createLead:{
          currentLeadData: action.data
        }
      }
    case LEADS_DELETE_CURRENT_LEADS_DATA:
      return{
        ...state,
        createLead:{
          ...state.createLead,
          currentLeadData: null
        }
      }
    default:
      return state;
  }
}